import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChlamydiaState {
  chlamydiaDialogOpen: boolean;
  chlamydiaId: null | string;
  chlamydiaUrl: null | string;
  urls: Map<string, string>;
}

const initialState: ChlamydiaState = {
  chlamydiaDialogOpen: false,
  chlamydiaId: null,
  chlamydiaUrl: null,
  urls: new Map(),
};

export const chlamydiaSlice = createSlice({
  name: "chlamydia",
  initialState,
  reducers: {
    openChlamydiaDialog: (state, action: PayloadAction<string>) => {
      state.chlamydiaDialogOpen = true;
      state.chlamydiaId = action.payload;
      const url = state.urls.get(action.payload);
      if (url) state.chlamydiaUrl = url;
    },
    closeChlamydiaDialog: (state) => {
      state.chlamydiaDialogOpen = false;
      state.chlamydiaId = null;
      state.chlamydiaUrl = null;
    },
  },
});

export const { openChlamydiaDialog, closeChlamydiaDialog } = chlamydiaSlice.actions;

export default chlamydiaSlice.reducer;
